import React from 'react';
import { Wrapper, Checked, Unchecked } from './style';

export function Radio({ isChecked = false, isDisabled = false, label, onClick, ...restProps }) {
  const rootId = restProps.id || 'grid-table-radio';

  return (
    <Wrapper
      {...restProps}
      id={rootId}
      isDisabled={isDisabled}
      onClick={!isDisabled ? onClick : () => {}}
      isChecked={isChecked}
    >
      {isChecked ? (
        <Checked id={`${rootId}-checked`}>
          <span></span>
        </Checked>
      ) : (
        <Unchecked id={`${rootId}-unchecked`} />
      )}
      <span id={`${rootId}-label`}>{label}</span>
    </Wrapper>
  );
}
